import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

import { Loader } from '../components/Loader';
import { enableScroll } from '../domains/UI/store/slice';
import { useAppDispatch, useAppSelector } from '../reduxstore/hooks';
import { Router } from './Router';
export const Layout: React.FC = () => {
	const disableScroll = useAppSelector(
		state => state.uiReducer.disableScroll
	);
	const location = useLocation();
	const dispatch = useAppDispatch();
	// for MobileNav scroll lock
	useEffect(() => {
		dispatch(enableScroll());
	}, [location, dispatch]);

	useEffect(() => {
		if (disableScroll) {
			document.body.style.overflowY = 'hidden';
		} else {
			document.body.style.overflowY = 'scroll';
		}

		return () => {
			document.body.style.overflowY = 'scroll';
		};
	}, [disableScroll]);

	// for desktop sticky footer

	return (
		<Loader title="Layout">
			<Router />
		</Loader>
	);
};

// const LayoutContainer = styled.div`
// 	min-height: 100vh;
// 	@media (max-width: 992px) {
// 		min-height: calc(100vh - 90px - 82px);
// 		padding-bottom: 82px;
// 	}
// `;

// const Body = styled.div`
// 	height: 100%;
// 	width: 100%;
// 	margin: 36px 0 60px 0;
// 	display: flex;
// 	flex-direction: column;
// 	justify-content: center;

// 	@media (max-width: 1200px) {
// 		padding: 24px;
// 	}

// 	@media (max-width: 768px) {
// 		margin: 0;
// 		padding: 16px;
// 		padding-top: 0;
// 		flex-direction: column;
// 	}
// `;

// const LayoutWrapper = styled.div`
// 	@media (max-width: 992px) {
// 		padding-bottom: 3rem;
// 	}
// `;
